import { SettingOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import ".././stylestabs.scss";
import MegaTable from "../../../../components/MagaTableV2";

const MaintenanceHistory = ({ stData = {} as any, stChange = (data: any, type: any) => { } }) => {

  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.customer_care_vehicle_histories?.list.map((col: any) => {
      temp.push({
        headerName: col.headerName,
        field: col.field,
        tooltipField: col.field,
      })
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheVehicleContactHistory',
    col: [
      ...tableColumns(stData.sourceColumnWarehouse),
      // { field: 'dms_doc_id', headerName: 'Id tiếp xúc' },
      // { field: 'doc_date_ct', headerName: 'Ngày tiếp xúc' },
      // { field: 'customer_interactions_approved_date', headerName: 'Ngày phê duyệt' },
      // { field: 'customer_interactions_note', headerName: 'Nội dung tiếp xúc' },
      // { field: 'status_name', headerName: 'Trạng thái' },
      // { field: 'status', headerName: 'Mã trạng thái' },
      // { field: 'group_status_code', headerName: 'Mã nhận định khách hàng' },
      // { field: 'group_staus_name', headerName: 'Nhận định khách hàng' },
      // { field: 'customer_interactions_box_code', headerName: 'Thùng' },
      // { field: 'customer_interactions_chassis_no', headerName: 'Số khung (VIN)' },
      // { field: 'customer_interactions_employee_code', headerName: 'Mã nhân viên' },
      // { field: 'customer_interactions_employee_name', headerName: 'Tên nhân viên' },
      // { field: 'group_employee_code', headerName: 'Mã nhóm nhân viên' },
      // { field: 'group_vehicle_code', headerName: 'Mã nhóm xe' },
      // { field: 'branch_name', headerName: 'Đơn vị tiếp xúc' },
      // { field: 'route_name', headerName: 'Điểm bán hàng tiếp xúc' },
    ],
    listData: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
    height: '400px',
  });

  useEffect(() => {
    if (stData.xesohuu_show) {
      stChange(stData.xesohuu_show.vehicle_interaction_history || [], 'vehicle_interaction_history');
    }
  }, [stData.xesohuu_show]);

  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>
      <MegaTable
        stData={{ ...megaTableData, listData: stData.xesohuu_show_vehicle_interaction_history || [], loading: false }}
        stChange={(data) => {
          setMegaTableData((prev: any) => ({ ...prev, ...data }));
        }}
      />
    </>
  );
};
export default MaintenanceHistory;
